import * as Dialog from "@radix-ui/react-dialog";
import React from "react";
import styles from "./Modal.module.scss";

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
}

const CustomModal: React.FC<Props> = ({
  open,
  onClose,
  title,
  subtitle,
  children,
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={open ? onClose : undefined}>
      <Dialog.Portal className={styles.portal}>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content className={styles.content}>
          {title ? (
            <Dialog.Title className={styles.title}>{title}</Dialog.Title>
          ) : null}

          <div className={styles.main}>
            {subtitle ? (
              <div className={styles.subtitle}>{subtitle}</div>
            ) : null}
            {children}
          </div>
          <Dialog.Close className={styles.close} data-testid="dialog-close">
            <i className="fas fa-times" />
          </Dialog.Close>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default CustomModal;
